<template>
  <div :class="`card-info ${isFull === true ? 'full' : ''}`">
    <div class="shadow-wrapper" @click="close"></div>
    <div class="content">
      <card>
        <header-item :card="card" />
        <tabs :tabs="tabs" :active="activeTab" v-model="activeTab" />
        <template v-for="(tab, key) in tabs">
          <div v-if="activeTab === key" :key="key">
            <main-info :item="info" :infoKeys="infoKeys"></main-info>
            <component
              v-if="key == 0"
              :is="tab.component"
              :id="id"
              :key="key"
              @info="setInfo"
            />
            <component v-else :is="tab.component" :id="id" />
          </div>
        </template>
        <slot></slot>

      </card>
      
    </div>
  </div>
</template>
<script>
import MainInfo from "@/components/Item/MainInfo";
export default {
  props: ["card", "activeTab", "tabs", "id", "isFull", "infoKeys"],
  components: {
    HeaderItem: () => import("./HeaderItem"),
    MainInfo,
  },
  methods: {
    setInfo(val) {
      this.info = JSON.parse(JSON.stringify(val));
    },
    close(event) {
      let query = Object.assign({}, this.$route.query);
      if (query[this.card]) {
        delete query[this.card];
      } else {
        return false;
      }
      this.$router.replace({query});
    },
  },
  data() {
    return {
      info: null,
    };
  },
};
</script>